import script from "./oasis-layout.vue?vue&type=script&setup=true&lang=ts"
export * from "./oasis-layout.vue?vue&type=script&setup=true&lang=ts"

import "./oasis-layout.vue?vue&type=style&index=0&id=3e6e9ef2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e6e9ef2"]])

export default __exports__